export const CAMPAIGN_ACTION_EDIT = 'edit';
export const CAMPAIGN_ACTION_DELETE = 'delete';
export const CAMPAIGN_ACTION_VIEW_REPORT = 'view_report';
